import { ConeControls } from "./ConeControls";
import { CoordsControls } from "./CoordsControls";
import { MarkerControls } from "./MarkerControls";
import { ResetControls } from "./ResetControls";
import { SaveControls } from "./SaveControls";
import { StartControls } from "./StartControls";

export class DetectorControls {

    public coords: CoordsControls;
    public cone: ConeControls;
    public marker: MarkerControls;
    public reset: ResetControls;
    public save: SaveControls;
    public start: StartControls;

    constructor() {
        this.coords = new CoordsControls();
        this.cone = new ConeControls();
        this.marker = new MarkerControls();
        this.reset = new ResetControls();
        this.save = new SaveControls();
        this.start = new StartControls();
    }   
}